/* eslint-disable */

import React from 'react';
import { graphql } from 'gatsby';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';

import { MainLayout } from '../layouts';

import { SliceZone } from '../components';

export const query = graphql`
  query ProductslinuxQuery($uid: String!) {
    prismic {
      productslinux(lang: "en-us", uid: $uid) {
        _meta {
          lang
          lastPublicationDate
          type
          uid
        }
        body {
        ... on PRISMIC_ProductslinuxBodyHerotext {
          type
            label
            primary {
              fullscreen
              large_text
              text_color
              background_color
              background_image
              display_primary_cta
              display_secondary_cta
              heading
              primary_cta_color
              primary_cta_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              primary_cta_text
              secondary_cta_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              secondary_cta_text
              subheading
              text_alignment
            }
        },
        ... on PRISMIC_ProductslinuxBodyPricingtable {
           type
label
primary {
  heading
  heading_color
  subheading
  subheading_color
  tooltip_text
  target_name
}
fields {
  column_text_1
  column_text_2
  column_text_3
  column_text_4
  column_text_5
  column_text_6
  column_text_7
  link_text
  link_url {
    ... on PRISMIC__ExternalLink {
      _linkType
      url
    }
  }
  link_text_not_logged_in
  link_url_not_logged_in {
    ... on PRISMIC__ExternalLink {
      _linkType
      url
    }
  }
  popular_column
}

        },
        ... on PRISMIC_ProductslinuxBodyListalternatingv2 {
          type
            label
            fields {
              list_alt_image
              list_alt_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              list_alt_link_text
              list_alt_text
              list_alt_title
              list_link_color
              list_text_color
              list_title_color
            }
            primary {
              background_color
              heading
              subheading
              background_image
              heading_color
              subheading_color
              text_color
            }
        },
        ... on PRISMIC_ProductslinuxBodyContentblock {
          type
            label
            primary {
              target_name
              background_color
              background_image
              content
              content_text_alignment
              heading
              heading_color
              image
              subheading
              subheading_color
              text_color
              wistia_id
            }
        }}
        date
        description
        path
        title
        open_graph_image
      }
    }
  }
`;

const Productslinux = ({ data, location }) =>
  data.prismic.productslinux ? (
    <MainLayout location={location} layout='productslinux'>
    <Helmet>
      <title>{(data.prismic.productslinux.title[0] && data.prismic.productslinux.title[0].text) || 'DigitalOcean'}</title>
      <link rel="canonical" href={data.prismic.productslinux.path  == '/' ? 'https://www.digitalocean.com' + data.prismic.productslinux.path : 'https://www.digitalocean.com' + data.prismic.productslinux.path + '/'} />
      <meta
        name="description"
        content={
          data.prismic.productslinux.description ||
          'Helping millions of developers easily build, test, manage, and scale applications of any size – faster than ever before.'
        }
      />
      <meta name="twitter:card" content="summary"/>
      <meta name="twitter:title" content={data.prismic.productslinux.title[0] ? data.prismic.productslinux.title[0].text : 'DigitalOcean'} />
      <meta name="twitter:description" content={data.prismic.productslinux.description ? data.prismic.productslinux.description : 'DigitalOcean'} />
      <meta name="twitter:image" property={data.prismic.productslinux.open_graph_image ? data.prismic.productslinux.open_graph_image.url : 'https://images.prismic.io/www-static/0026a57b93abe5b04413765253903472dab58e11_general-droplets_blog-v4_twitter---facebook.png?auto=compress,format'} />
      <meta property="og:type" content="website" />
      <meta property="og:description" content={data.prismic.productslinux.description ? data.prismic.productslinux.description : 'DigitalOcean'} />
      <meta property="og:title" content={data.prismic.productslinux.title[0] ? data.prismic.productslinux.title[0].text : 'DigitalOcean'} />
      <meta property="og:url" content={data.prismic.productslinux.path  == '/' ? 'https://www.digitalocean.com' + data.prismic.productslinux.path : 'https://www.digitalocean.com' + data.prismic.productslinux.path + '/'} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="600" />
      <meta property="og:image" content={data.prismic.productslinux.open_graph_image ? data.prismic.productslinux.open_graph_image.url : 'https://images.prismic.io/www-static/0026a57b93abe5b04413765253903472dab58e11_general-droplets_blog-v4_twitter---facebook.png?auto=compress,format'} />
    </Helmet>
      <SliceZone allSlices={data.prismic.productslinux.body} />
    </MainLayout>
  ) : null;

Productslinux.propTypes = {
  data: PropTypes.object.isRequired,
};

export default Productslinux;
